import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Link } from 'gatsby';
import OImage from '../OImage';

import Wysiwyg from '../Wysiwyg';
import { externalLink } from '../../ui/helpers';

import ButtonTertiary from '../ButtonTertiary';
import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import { Container, Top, Bottom, Card } from './styles';

interface ICard {
  key: string;
  field_title?: string;
  field_text?: string;
  field_link?: { uri?: string; title?: string };
  field_media: any;
  field_hash_link_element_id?: string;
}
interface IProps {
  theme?: string;
  heading?: string;
  title?: string;
  text?: string;
  cards: Array<ICard>;
}

const isBrowser = typeof window !== 'undefined';

const IconText = ({ theme, heading, title, text, cards }: IProps) => {
  const cleanedTheme = theme ? theme : 'white';
  return (
    <ThemeProvider theme={themes.basic[cleanedTheme]}>
      <Container>
        {(title || text) && (
          <Wrapper size="reader" as={Top}>
            {title &&
              (heading === 'heading_2' ? (
                <h2 className="title">{title}</h2>
              ) : (
                <h3 className="title">{title}</h3>
              ))}

            {text && <p className="description">{text}</p>}
          </Wrapper>
        )}
        <Wrapper size="mainwrapper" as={Bottom}>
          {cards.map(card => (
            <Card
              key={card.key}
              data-gtm-action={`icon-text_${card?.field_title}`}
              data-gtm-category="cta"
              className={isBrowser && card?.field_hash_link_element_id ? 'pointer' : undefined}
              onClick={isBrowser && card?.field_hash_link_element_id ? () => {window.location.href = `#${card.field_hash_link_element_id}`} : undefined}
            >
              {card.field_link?.uri ? (
                externalLink(card.field_link?.uri) ? (
                  <a
                    aria-label={`This image is a link to: ${card.field_link?.uri} (will be opened in a new window)`}
                    href={card.field_link?.uri}
                    target={'_blank'}
                    rel="nofollow noopener noreferrer"
                    data-gtm-event
                    data-gtm-label={`${card.field_link?.title}_${
                      isBrowser ? window.location.href : ''
                    }`}>
                    <OImage
                      bg={card.field_media?.url}
                      aspectRatio={100 / 100}
                      className="icon"
                      alt={card.field_media?.alt || ''}
                    />
                  </a>
                ) : (
                  <Link
                    to={card.field_link?.uri}
                    aria-label={`This image is a link to an internal section of this site: ${card.field_link?.uri}`}
                    data-gtm-event
                    data-gtm-label={`${card.field_link?.title}_${
                      isBrowser ? window.location.href : ''
                    }`}>
                    <OImage bg={card.field_media?.url} aspectRatio={100 / 100} className="icon" />
                  </Link>
                )
              ) : (
                <OImage bg={card.field_media?.url} aspectRatio={100 / 100} className="icon" />
              )}

              {card.field_title && <div className="title-card">{card.field_title}</div>}
              {card.field_text && (
                <Wysiwyg
                  className="description-card"
                  text={card?.field_text}
                  theme={cleanedTheme}
                />
              )}
              {card.field_link?.title && card.field_link?.uri && (
                <ButtonTertiary
                  to={card.field_link?.uri}
                  target={`${externalLink(card.field_link?.uri) && '_blank'}`}
                  label={card.field_link.title}
                  data-gtm-event
                  data-gtm-label={`${card.field_link?.title}_${
                    isBrowser ? window.location.href : ''
                  }`}
                />
              )}
            </Card>
          ))}
        </Wrapper>
      </Container>
    </ThemeProvider>
  );
};

export default IconText;
